import { EquipmentSelectV2 } from '@frontend/equipment/select';
import { updateField } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

import useEquipmentConstraintDataInput from './equipment-constraint-data-input.controller';

const ID = 'equipment-constraint-data-input';
export interface EquipmentConstraintDataInputProps {
    dispatch: ThunkDispatch<any, any, Action>;
    formId: string;
    id?: string;
    label?: string;
    className?: string;
    required?: boolean;
}

const EquipmentConstraintDataInput = (props: EquipmentConstraintDataInputProps) => {
    const viewProps = useEquipmentConstraintDataInput(props);

    return (
        <div
            id={ID}
            className='flex w-full flex-row'>
            <EquipmentSelectV2
                required
                value={viewProps.formValues?.equipment_id ?? null}
                onChange={(v) => {
                    props.dispatch(updateField({ formId: props.formId, key: 'data', value: v ? { equipment_id: v } : undefined }));
                }}
            />
        </div>
    );
};

export default EquipmentConstraintDataInput;
